<template>
    <v-data-table :headers="headers" :items="filteredProxies" item-key="name" items-per-page="-1"
        class="border h-[500px] bg-white text-black min-h-[500px]" style="font-size: 13px;" :style="`height: ${computedHeight}px;`">

        <template v-slot:[`item.no`]="{ index }">
            {{ index + 1 }}
        </template>
        <template v-slot:[`item.modem`]="{ item }">
            <div class="flex items-center">
                <v-icon icon="mdi-circle" size="15" :color="item.status === 'CONNECTED' && item.modem_status === true ? 'green' : 'red'"
                    class="mr-2"></v-icon>
                {{ item.modem }}
            </div>
        </template>
        <template v-slot:[`item.offline_info`]="{ item }">
            <div class="text-xs leading-tight">
                <div>{{ offlineFor(item) }}</div>
                <div :style="item.offline_reason === 'Proxy offline' ? 'color: #dc2626' : 'color: #64748b'">
                    {{ item.offline_reason || '-' }}
                </div>
                <div v-if="item.live_status" :style="item.live_status === 'offline' ? 'color: #dc2626' : (item.live_status === 'rotating' || item.live_status === 'checking' || item.live_status === 'disagrees') ? 'color: #d97706' : 'color: #64748b'">
                    {{ liveLabel(item.live_status) }}
                </div>
            </div>
        </template>
        <template v-slot:[`item.ports`]="{ item }">
            <v-icon icon="mdi-alpha-h-circle-outline" color="green"></v-icon>
            {{ item.http_port }} /
            <v-icon icon="mdi-alpha-s-circle-outline" color="green"></v-icon>
            {{ item.sock_port }}
        </template>
        <template v-slot:[`item.pos`]="{item}">
            {{ item.proxyType === 'XPROXY' ? item.position : item.imei }}
        </template>
        <template v-slot:[`item.checkbox`]="{ item }">
            <div @click="toggleSelection(item)" class="ml-auto align-self-center "
                style="width: 20px; height: 20px; cursor: pointer;">
                <input :checked="isSelected(item)" class="form-check-input shadow-none" type="checkbox" />
            </div>
        </template>
        <template v-slot:[`item.usage_status`]="{ item }">
            {{ item.active === 'inactive' ? 'PAUSED' : item.usage_status }}
        </template>
        <!-- <template v-slot:[`item.dl_bytes`]="{ item }">
            {{ item.dl_bytes }} MB
        </template>
        <template v-slot:[`item.all_bytes`]="{ item }">
            {{ item.all_bytes }} MB
        </template> -->
        <template v-slot:[`item.bytes`]="{ item }">
            <div v-if="item.modem_type==='X_PROXY'">
                <div :style="checkDownloadLimit(item, item.http_dl_bytes) ? 'color: red' : ''">
                    HTTP: 
                    {{ item.http_dl_bytes }} MB
                </div>
                <div :style="checkDownloadLimit(item, item.sock_dl_bytes) ? 'color: red' : ''">
                    SOCKS5:  
                    {{ item.sock_dl_bytes }} MB
                </div>
            </div>
            <div v-else-if="item.modem_type==='PROXYSMART'">
                <div :style="checkDownloadLimit(item, item.dl_bytes) ? 'color: red' : ''">
                    {{ item.dl_bytes }}
                </div>
            </div>
        </template>
        <template v-slot:[`item.buttonBar`]="{item}">
            <v-menu offset-y location="bottom">
                <template v-slot:activator="{ props, on, isActive }">
                    <v-btn v-bind="props" v-on="{ ...on }" density="compact"
                        :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                        style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                        Actions
                        <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                    </v-btn>
                </template>
                <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                    style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                    <v-btn v-for="(button, index) in actionButtons" :key="index" @click="clickAction(item, button)"
                        rounded="0" class="text-center bg-dark text-light"
                        style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                        :data-bs-toggle="button === 'Update' && 'modal'"
                        :data-bs-target="button === 'Update' && item.modem_type === 'X_PROXY'?'#xproxyUpdateModal':'#proxysmartUpdateModal'">
                        {{button === 'Active' ? item.active === 'active' ? 'Pause' : 'Resume' : button }}
                    </v-btn>
                </v-list>
            </v-menu>
            <!-- <v-btn
                @click="clickAction(item)" rounded="0" class="text-center bg-dark text-light "
                style="font-size: 10px; width: 80px; outline: none; border-bottom: 1px solid #345; height: 30px"
                :data-bs-toggle="'modal'"
                :data-bs-target="item.modem_type === 'X_PROXY'?'#xproxyUpdateModal':'#proxysmartUpdateModal'"
                >Update</v-btn> -->
        </template>
    </v-data-table>
    <UpdateDialoagXProxy :item="selectedItem" @updated="updatedHandler"/>
    <UpdateDialogProxySmart :item="selectedItem" @updated="updatedHandler"/>
</template>

<script setup>
import { ref, watchEffect, defineProps, defineExpose, onMounted, onBeforeUnmount } from 'vue';
import { useAdminProxyStore, useAlertStore } from "@/stores"
import UpdateDialoagXProxy from './Modals/UpdateDialoag-XProxy.vue';
import UpdateDialogProxySmart from './Modals/UpdateDialog-ProxySmart.vue';
import { storeToRefs } from 'pinia';
const adminProxyStore = useAdminProxyStore()
const { xProxies, smartProxies } = storeToRefs(adminProxyStore)
const filteredProxies = ref([])
const filteredProxies1 = ref([])

const actionButtons = ref(
    ["Update", "Active"]
)

const props = defineProps({
    selectedSaleStatus: {
        type: Object, // Assuming user object has a name property
        required: true
    },
    selectedServerName: {
        type: Object, // Assuming user object has a name property
        required: true
    },
    selectedServerType: {
        type: Object, // Assuming user object has a name property
        required: true
    },
});


const headers = ref(
    
);

const checkDownloadLimit = (item, value) => {
    if(item.modem_type==='X_PROXY') {
        if(item.downloadLimitType !== 'unlimited' && item.downloadLimitTimeUnit.toUpperCase() === "DAILY" && parseFloat(item.downloadLimitAmount) <= parseFloat(value)) {
            return true
        }
        else return false
    } else {
        if(Number(value) !== 0 && item.quotaDirType === 'Download' && item.quotaTimeUnit.toUpperCase() === "DAILY") {
            const regex = /(\d+(\.\d+)?)\s*(\w+)/;
            const matches = value.match(regex);
            if(matches[3]?.toUpperCase() === 'MB' && parseFloat(matches[1]) >= parseFloat(item.quotaAmount)) return true
            else if(matches[3]?.toUpperCase() === 'GB' && (parseFloat(matches[1]) * 1024) >= parseFloat(item.quotaAmount)) return true
            else return false

        } else return false
    }
}

const selectedSaleStatus = ref('All');
const nowMs = ref(Date.now());

const offsetHeight = 400; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);
let offlineDurationTimer = null;

const handleResize = () => {
  computedHeight.value = window.innerHeight - offsetHeight;
};

const formatOfflineDuration = (secondsValue) => {
    const seconds = Number(secondsValue);
    if (!Number.isFinite(seconds) || seconds <= 0) return 'Under alert threshold';

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `~${minutes} min${minutes === 1 ? '' : 's'}`;

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (hours < 24) {
        return remainingMinutes > 0 ? `~${hours}h ${remainingMinutes}m` : `~${hours}h`;
    }

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    return remainingHours > 0 ? `~${days}d ${remainingHours}h` : `~${days}d`;
};

const offlineFor = (item) => {
    if (item.offline_reason !== 'Proxy offline') return item.offline_for || '-';

    const offlineSeconds = Number(item.offline_seconds);
    if (!Number.isFinite(offlineSeconds)) return item.offline_for || '-';

    const checkedAtMs = Date.parse(item.offline_checked_at);
    const elapsedSeconds = Number.isFinite(checkedAtMs)
        ? Math.max(0, Math.floor((nowMs.value - checkedAtMs) / 1000))
        : 0;

    return formatOfflineDuration(offlineSeconds + elapsedSeconds);
};

const offlineSortSeconds = (item) => {
    const backendSortSeconds = Number(item.offline_sort_seconds);
    if (Number.isFinite(backendSortSeconds)) return backendSortSeconds;

    if (item.offline_reason !== 'Proxy offline') return 0;

    const offlineSeconds = Number(item.offline_seconds);
    if (!Number.isFinite(offlineSeconds)) return 0;

    const checkedAtMs = Date.parse(item.offline_checked_at);
    const elapsedSeconds = Number.isFinite(checkedAtMs)
        ? Math.max(0, Math.floor((Date.now() - checkedAtMs) / 1000))
        : 0;

    return offlineSeconds + elapsedSeconds;
};

const sortByOfflineDuration = (items) => {
    return [...items].sort((a, b) => offlineSortSeconds(b) - offlineSortSeconds(a));
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
  offlineDurationTimer = setInterval(() => {
    nowMs.value = Date.now();
  }, 15000);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  if (offlineDurationTimer) clearInterval(offlineDurationTimer);
});

const selectedItems = ref([])
const selectedItem = ref(null)
let updateInfoDialogFlag = ref(false)

const clickAction = (item, button) => {
    switch (button) {
        case "Update":
            selectedItem.value = item
            updateInfoDialogFlag = true;
            break
        case "Active":
            adminProxyStore.updateAction(item.uuid)

    }
}
const updatedHandler = () => {
    updateInfoDialogFlag.value = false
}
// X-Proxy rows are confirmed against the box on every load (ports already back online are not listed)
const liveLabel = (s) => ({ pending: 'Live check: checking the box…', disagrees: 'Live check: server says online, database says offline', offline: 'Live check: still offline', rotating: 'Live check: rotating', checking: 'Live check: confirming (re-read in 15 s)', unknown: 'Live check: box did not answer', server_offline: 'Server offline' }[s] || '')

watchEffect(() => {

    if (props.selectedServerType === 'X_PROXY' || props.selectedServerType === 'XPROXY_NEW' || props.selectedServerType === 'XPROXY_NEW_2PORT') {
        filteredProxies.value = sortByOfflineDuration(xProxies.value.filter(proxy =>
            (proxy.usage_status.toUpperCase() === selectedSaleStatus.value.toUpperCase() || selectedSaleStatus.value === 'All') &&
            (proxy.modem_type === 'X_PROXY') && (props.selectedServerType === 'XPROXY_NEW' ? proxy.variant === 'v2'
                : props.selectedServerType === 'XPROXY_NEW_2PORT' ? proxy.variant === 'v2-2port'
                : proxy.variant !== 'v2' && proxy.variant !== 'v2-2port')
        ));
        headers.value = [
        { title: 'No', align: 'center', key: 'no' },
        { title: '', align: 'center', key: 'checkbox' },
        { title: 'Modem', align: 'center', key: 'modem' },
        { title: 'Offline', align: 'center', key: 'offline_info' },
        { title: 'Position', align: 'center', key: 'position' },
        { title: 'Ports', align: 'center', key: 'ports' },
        // { title: 'UL Counter', align: 'center', key: 'ul_bytes' },
        // { title: 'DL Counter', align: 'center', key: 'dl_bytes' },
        // { title: 'All Counter', align: 'center', key: 'all_bytes' },
        { title: 'Download', align: 'center', key: 'bytes' },
        // { title: 'Counter Updated', align: 'center', key: 'counter_updated' },
        { title: 'Authentication User', align: 'center', key: 'auth_user' },
        { title: 'Authorization IPs', align: 'center', key: 'auth_ips' },
        { title: 'Usage Status', align: 'center', key: 'usage_status' },
        // { title: 'Status', align: 'center', key: 'status' },
        { title: 'Customer', align: 'center', key: 'customer_name' },
        { title: 'Action', align: 'center', key: 'buttonBar' },
    ]
    }
    else if (props.selectedServerType === 'PROXYSMART') {
        filteredProxies.value = sortByOfflineDuration(smartProxies.value.filter(proxy =>
            (proxy.usage_status.toUpperCase() === selectedSaleStatus.value.toUpperCase() || selectedSaleStatus.value === 'All') &&
            (proxy.modem_type === props.selectedServerType)
        ));
        
        headers.value = [
        { title: 'No', align: 'center', key: 'no' },
        { title: '', align: 'center', key: 'checkbox' },
        { title: 'Modem', align: 'center', key: 'modem' },
        { title: 'Offline', align: 'center', key: 'offline_info' },
        { title: 'IMEI', align: 'center', key: 'imei' },
        { title: 'Ports', align: 'center', key: 'ports' },
        // { title: 'UL Counter', align: 'center', key: 'ul_bytes' },
        // { title: 'DL Counter', align: 'center', key: 'dl_bytes' },
        // { title: 'All Counter', align: 'center', key: 'all_bytes' },
        { title: 'Download', align: 'center', key: 'bytes' },
        // { title: 'Counter Updated', align: 'center', key: 'counter_updated' },
        { title: 'Authentication User', align: 'center', key: 'auth_user' },
        { title: 'Authorization IPs', align: 'center', key: 'auth_ips' },
        { title: 'Usage Status', align: 'center', key: 'usage_status' },
        // { title: 'Status', align: 'center', key: 'status' },
        { title: 'Customer', align: 'center', key: 'customer_name' },
        { title: 'Action', align: 'center', key: 'buttonBar' },
    ]
    }
    else if (props.selectedServerType === 'ALL') {
        filteredProxies.value = smartProxies.value.filter(proxy =>
            (proxy.usage_status.toUpperCase() === selectedSaleStatus.value.toUpperCase() || selectedSaleStatus.value === 'All') &&
            (proxy.modem_type === 'PROXYSMART')
        );
        filteredProxies1.value = xProxies.value.filter(proxy =>
            (proxy.usage_status.toUpperCase() === selectedSaleStatus.value.toUpperCase() || selectedSaleStatus.value === 'All') &&
            (proxy.modem_type === 'X_PROXY')
        );
        filteredProxies1.value.forEach(proxy => {
            filteredProxies.value.push({...proxy, proxyType: 'XPROXY'})
        });
        filteredProxies.value = sortByOfflineDuration(filteredProxies.value);
        headers.value = [
        { title: 'No', align: 'center', key: 'no' },
        { title: '', align: 'center', key: 'checkbox' },
        { title: 'Modem', align: 'center', key: 'modem' },
        { title: 'Offline', align: 'center', key: 'offline_info' },
        { title: 'IMEI Or Position', align: 'center', key: 'pos' },
        { title: 'Ports', align: 'center', key: 'ports' },
        // { title: 'UL Counter', align: 'center', key: 'ul_bytes' },
        // { title: 'DL Counter', align: 'center', key: 'dl_bytes' },
        // { title: 'All Counter', align: 'center', key: 'all_bytes' },
        { title: 'Download', align: 'center', key: 'bytes' },
        // { title: 'Counter Updated', align: 'center', key: 'counter_updated' },
        { title: 'Authentication User', align: 'center', key: 'auth_user' },
        { title: 'Authorization IPs', align: 'center', key: 'auth_ips' },
        { title: 'Usage Status', align: 'center', key: 'usage_status' },
        // { title: 'Status', align: 'center', key: 'status' },
        { title: 'Customer', align: 'center', key: 'customer_name' },
        { title: 'Action', align: 'center', key: 'buttonBar' },
    ]
    }
}, [xProxies.value, smartProxies.value, selectedSaleStatus.value, props.selectedServerType])


const isSelected = (item) => {
    return selectedItems.value.includes(item);
};
const toggleSelection = (item) => {
    const index = selectedItems.value.indexOf(item);
    if (index === -1) {
        selectedItems.value.push(item)
    } else {
        selectedItems.value.splice(index, 1)
    }
};

watchEffect(() => {
    selectedSaleStatus.value = props.selectedSaleStatus
}, [props.selectedSaleStatus])


const updateActive = (item) => {
    adminProxyStore.updateAction(item.uuid)
}

const deleteProxies = () => {

    // Your logic to delete proxies
    if (selectedItems.value.find(item => item.usage_status.toUpperCase() === 'USED')) {
        const alertStore = useAlertStore()
        alertStore.warning("Can't delete used proxies")
        return
    }
    adminProxyStore.deleteProxy(selectedItems.value.map(item => item.uuid)).then(() => {
        selectedItems.value = []
        adminProxyStore.loadDisProxies(props.selectedServerName)
    })

}
defineExpose({
    deleteProxies
});
</script>
